interface LocalStorageKey {
  key: string;
  description: string; //describe what this key stores
  type?: string; //data type this key stores
}

export const LocalStorageKeys: { [name: string]: LocalStorageKey } = {
  IdleMonitorTimeout: {
    key: 'IdleMonitorTimeout',
    description: 'Idle monitor key to handle timeout of multiple browser sessions using local storage',
    type: 'boolean',
  },
  IdleMonitorLastRefreshed: {
    key: 'IdleMonitorLastRefreshed',
    description: 'Idle monitor key to handle refresh of multiple browser sessions using local storage',
    type: 'Date',
  },
  ApplicationVersion: {
    key: 'ApplicationVersion',
    description: 'Stores the last application version loaded on the browser',
    type: 'string',
  },
};
